export const LOAD_STATISTIC = 'LOAD_STATISTIC';
export const LOADED_STATISTIC = 'LOADED_STATISTIC';